import { pushToDataLayer } from '../../ga4Tracking/datalayer';

type trackIsPerksProps = {
  isLoggedIn?: boolean;
  isPerks?: boolean;
  coupon?: string;
  couponId?: string;
  couponCount?: number;
};
export const trackPageView = ({ isLoggedIn, isPerks, coupon, couponId, couponCount }: trackIsPerksProps) => {
  pushToDataLayer({
    event: 'page_view',
    customer: {
      is_logged_in: !!isLoggedIn,
      is_perks_member: !!isPerks,
      coupon: coupon,
      coupon_id: couponId,
      coupon_count: couponCount,
    },
  });
};
